import { useEffect, useRef } from "react";

const useMouseDown = (callback: (e: MouseEvent) => void, dependencies: any) => {
  const saveCallback = useRef<any>(callback);

  useEffect(() => {
    saveCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    window.addEventListener("mousedown", saveCallback.current, true);

    return () => {
      window.removeEventListener("mousedown", saveCallback.current, true);
    };
  }, [saveCallback, ...dependencies]);
};

export default useMouseDown;
